/* eslint-disable max-len */
import _ from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export const appendMetadataWithIndex = (metadata, index) => {
    if (metadata.id && metadata.defaultMessage) {
        // it is just a text message, do not modify it
        return metadata;
    }
    // skip 'id' update of no 'id' exists (e.g. contentRepeat doesn't have it)
    let defaultChanges = metadata.id ? {
        ...metadata,
        id: `${metadata.id}${index}`
    } : metadata;
    // extended auto-indexing logic to: content, contentAfter, contentBefore, contentRepeat and for Object and Array
    if (_.isArray(defaultChanges.content)) {
        defaultChanges = {
            ...defaultChanges,
            content: defaultChanges.content.map((content) => appendMetadataWithIndex(content, index))
        };
    } else if (_.isObject(defaultChanges.content)) {
        defaultChanges = {
            ...defaultChanges,
            content: appendMetadataWithIndex(defaultChanges.content, index)
        };
    }
    if (_.isArray(defaultChanges.contentRepeat)) {
        defaultChanges = {
            ...defaultChanges,
            contentRepeat: defaultChanges.contentRepeat.map((content) => appendMetadataWithIndex(content, index))
        };
    } else if (_.isObject(defaultChanges.contentRepeat)) {
        defaultChanges = {
            ...defaultChanges,
            contentRepeat: appendMetadataWithIndex(defaultChanges.contentRepeat, index)
        };
    }
    if (_.isArray(defaultChanges.contentAfter)) {
        defaultChanges = {
            ...defaultChanges,
            contentAfter: defaultChanges.contentAfter.map((content) => appendMetadataWithIndex(content, index))
        };
    } else if (_.isObject(defaultChanges.contentAfter)) {
        defaultChanges = {
            ...defaultChanges,
            contentAfter: appendMetadataWithIndex(defaultChanges.contentAfter, index)
        };
    }
    if (_.isArray(defaultChanges.contentBefore)) {
        defaultChanges = {
            ...defaultChanges,
            contentBefore: defaultChanges.contentBefore.map((content) => appendMetadataWithIndex(content, index))
        };
    } else if (_.isObject(defaultChanges.contentBefore)) {
        defaultChanges = {
            ...defaultChanges,
            contentBefore: appendMetadataWithIndex(defaultChanges.contentBefore, index)
        };
    }
    return defaultChanges;
};